"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RuleConstants_1 = require("./RuleConstants");

var RULE_CONDITION_DROPDOWN_OPTIONS = [{
  value: RuleConstants_1.CONDITION_TYPES.GTE,
  paired: ['LT', 'LTE']
}, {
  value: RuleConstants_1.CONDITION_TYPES.LTE,
  paired: ['GT', 'GTE']
}, {
  value: RuleConstants_1.CONDITION_TYPES.GT,
  paired: ['LT', 'LTE']
}, {
  value: RuleConstants_1.CONDITION_TYPES.LT,
  paired: ['GT', 'GTE']
}];
var RULE_CONDITION_KPI_DROPDOWN_OPTION = {
  value: undefined,
  paired: ['LT', 'LTE', 'GT', 'GTE', 'ET']
};
var RULE_CONDITION_XTAB_TABLE_DROPDOWN_OPTION_SCALE_PERCENT = {
  value: undefined,
  paired: ['LT', 'LTE', 'GT', 'GTE', 'ET', 'IT', 'IB']
};

var RuleOptions =
/** @class */
function () {
  function RuleOptions() {}

  RuleOptions.getRuleOptionsBaseOnVisType = function (isKpi, scale) {
    var isNumericScale = scale === RuleConstants_1.RULE_SCALES.NUMERIC;
    return __spreadArrays(RULE_CONDITION_DROPDOWN_OPTIONS, [isKpi || isNumericScale ? RULE_CONDITION_KPI_DROPDOWN_OPTION : RULE_CONDITION_XTAB_TABLE_DROPDOWN_OPTION_SCALE_PERCENT]);
  };

  RuleOptions.getEndConditionTypeBaseOnStartCondtionType = function (startConditionType) {
    var type;

    if ([RuleConstants_1.RULE_OPERATORS.lessThan, RuleConstants_1.RULE_OPERATORS.lessThanOrEqualTo].includes(startConditionType)) {
      type = RuleConstants_1.RULE_OPERATORS.greaterThanOrEqualTo;
    } else if ([RuleConstants_1.RULE_OPERATORS.greaterThan, RuleConstants_1.RULE_OPERATORS.greaterThanOrEqualTo].includes(startConditionType)) {
      type = RuleConstants_1.RULE_OPERATORS.lessThanOrEqualTo;
    }

    return type;
  };

  return RuleOptions;
}();

exports.default = RuleOptions;
